import React from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

export default function InputGroup({
  label,
  type = 'text',
  name,
  value,
  onChange,
  disabled = false,
  className = '',
  helper = null,
  errorMessage = null,
  onRefChange = () => {},
  onBlur = () => {},
  isRequired = false,
  containerClassName = 'flex flex-col flex-1',
}) {
  let renderedErrorMessage = '';
  let errorIndicator = '';
  if (errorMessage) {
    renderedErrorMessage = (
      <p className="mt-2 text-sm text-giveRed-800" key="error-message">
        {errorMessage}
      </p>
    );

    errorIndicator = (
      <div
        className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
        key="error-indicator"
      >
        <ExclamationCircleIcon className="h-5 w-5 text-giveRed-800" aria-hidden="true" />
      </div>
    );
  }

  return (
    <div className={containerClassName}>
      <div className={`flex flex-row items-center rounded-md ${className}`}>
        <div className="flex-0 p-3 rounded-l-md bg-giveGray-200 border border-solid border-giveGray-300 whitespace-nowrap">
          {label}
        </div>
        <div className={`relative w-full flex ${isRequired ? 'flex-col' : null}`}>
          <input
            type={type}
            ref={onRefChange}
            name={name}
            disabled={disabled}
            className={`w-full p-3 rounded-r-md ${
              !isRequired ? 'border' : 'border-2'
            } border-${
              isRequired ? 'giveRed' : 'giveGray'
            }-300 -ml-1 border-solid focus:border-mint-600 focus:ring focus:ring-mint-600 focus:ring-opacity-25`}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
          />
          {errorIndicator}
        </div>
      </div>
      {isRequired && <span className="text-mint-600">Required</span>}
      {helper}
      {renderedErrorMessage}
    </div>
  );
}
